import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn, UserPlus } from "lucide-react";
import { useAuthState } from "@/context/useAuthState";
import { UserMenu } from "@/components/Auth/UserMenu";

type Props = { isBar?: boolean; floating?: boolean };

export function HeaderActionsPill({ isBar, floating }: Props) {
  const { user } = useAuthState();
  const navigate = useNavigate();

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-1.5 pt-2 pb-1 transition-all duration-300 ${
        floating
          ? "rounded-b-2xl border border-t-0 border-white/20 bg-[#1F2240]/90 shadow-[0_10px_30px_rgba(15,23,42,0.35)] backdrop-blur-md"
          : "rounded-xl bg-transparent"
      }`}
    >
      {user ? (
        <UserMenu />
      ) : (
        <Button
          variant="ghost"
          size="sm"
          className={`h-9 rounded-full px-4 font-semibold ${
            floating
              ? "text-white hover:bg-white/10 hover:text-white"
              : isBar
              ? "text-[#1F2240] hover:bg-[#E10F18]/10 hover:text-[#E10F18]"
              : "text-white hover:bg-white/10 hover:text-white"
          }`}
          onClick={() => navigate("/login")}
        >
          <LogIn className="mr-2 h-4 w-4" />
          Acceder
        </Button>
      )}
      {!user && (
        <Button
          variant="default"
          size="sm"
          className="h-9 rounded-full bg-[#E10F18] px-4 font-semibold text-white hover:bg-[#C70D16] shadow-sm"
          onClick={() => navigate("/registro")}
        >
          <UserPlus className="mr-2 h-4 w-4" />
          Registrarme
        </Button>
      )}
    </div>
  );
}
